import { useEffect } from 'react';

// import useCountdown from '@/features/v2/summaryForms/hooks/useCountdown';
import { FORM_DATA_KEY_FACTORY, useFormDataQuery } from '@/api/getters';
// import {
//   useFormMutation,
//   useSendOfferEnvelop,
//   useSubmitStagesMutation,
// } from '@/api/setters';
import { DocumentStatuses, Stages } from '@/api/types';
// import SignBadge from '@/components/SignBadge';
// import AfterDoc from '@/components/ui/AfterDoc';
// import Button, {
//   ButtonLoading,
//   ButtonRightArrow,
// } from '@/components/ui/Button';
// import { Hint } from '@/components/ui/Hint';
// import { CONSULTANTS } from '@/features/v2/consultants';
import { useAdditionalInfoContext } from '@/features/v2/lib/additionalInfo';
// import { useStepper } from '@/features/v2/lib/stepper';
import SummaryModal from '@/features/v2/summaryForms/components/stages/SummaryModal';
import TempSignDocuments from '@/features/v2/summaryForms/components/stages/TempSignDocuments';
import { queryClient } from '@/lib/query';

// import { useAutoAnimate } from '@formkit/auto-animate/react';
// import { useLingui } from '@lingui/react';
import { useParams } from 'react-router-dom';

const SignDocuments = () => {
  // const { i18n } = useLingui();
  const { data } = useFormDataQuery();
  const { id: hash } = useParams();
  // const sentDocuments = useSendOfferEnvelop();

  const generatedDocumentStatuses = data?.documents;

  // const date = data?.send_for_signature
  //   ? new Date(data?.send_for_signature)
  //   : null;

  const documentsSent = generatedDocumentStatuses?.some(
    (item) =>
      item.status === DocumentStatuses.SENT ||
      item.status === DocumentStatuses.DELIVERED
  );

  // const isReady = generatedDocumentStatuses?.every(
  //   (item) => item.status === DocumentStatuses.COMPLETED
  // );

  // const { step, innerObject, innerStep, setStep } = useStepper();

  // const submitStages = useSubmitStagesMutation();

  const { modalSummary, toggleModalSummary } = useAdditionalInfoContext();
  // const { mutateAsync } = useFormMutation();

  // const { duration, formattedMinutes, prevState } = useCountdown(date);

  // const disabled = date && Number(duration) >= 1;

  useEffect(() => {
    if (data?.stage === Stages.STAGE_V && documentsSent) {
      let refreshCount = parseInt(
        localStorage.getItem('refreshCountSigningDocuments') || '0',
        10
      );

      const maxRefreshes = 100;
      const interval = setInterval(() => {
        if (refreshCount >= maxRefreshes) {
          clearInterval(interval);
        } else {
          queryClient.invalidateQueries({
            queryKey: FORM_DATA_KEY_FACTORY(hash),
          });
          refreshCount++;

          localStorage.setItem(
            'refreshCountSigningDocuments',
            refreshCount.toString()
          );
        }
      }, 1000 * 10); // every 10 seconds

      return () => clearInterval(interval);
    }

    // if (duration && Number(duration) === 0) {
    //   queryClient.invalidateQueries({
    //     queryKey: FORM_DATA_KEY_FACTORY(hash),
    //   });
    // }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data?.stage, documentsSent]);

  // const [parent] = useAutoAnimate({
  //   duration: 200,
  // });

  if (!data) return null;

  return (
    <>
      <TempSignDocuments amount={data?.offer.surcharge_summary ?? 0} />
      {/* <AfterDoc
        consultant={CONSULTANTS.EWELINA_ASSISTANT}
        title={i18n.t('Dokumenty gotowe do podpisu!')}
        thankYouMessage={
          <>
            {i18n.t('W celu otrzymania')}{' '}
            {Number(data?.offer.surcharge_summary ?? 0).toLocaleString('PL', {
              style: 'currency',
              currency: 'PLN',
              minimumFractionDigits: 0,
              maximumFractionDigits: 0,
            })}{' '}
            {i18n.t(
              'wymagamy podpisu pełnomocnictwa do zawarcia w Twoim imieniu umowy cesji wierzytelności.'
            )}
          </>
        }
      >
        <>
          <p className="body">
            {i18n.t(
              'Przed podpisem zweryfikuj, czy wszystkie Twoje dane są poprawne oraz zapoznaj się ze wzorem umowy, która zostanie zawarta na podstawie podpisanego pełnomocnictwa.'
            )}
          </p>
          <div>
            <p className="body">
              {i18n.t(
                'Po kliknięciu w "Wyślij do podpisu" będą na Ciebie czekać:'
              )}
            </p>
            <ul className="body list-disc pl-6">
              <li>{i18n.t('Pełnomocnictwo')},</li>
              <li>{i18n.t('Oświadczenie poszkodowanego,')}</li>
              <li>{i18n.t('Oświadczenie o częściach oryginalnych,')}</li>
              <li>{i18n.t('Oświadczenie o współwłasności (opcjonalnie).')}</li>
            </ul>
          </div>
          <div ref={parent} className="flex flex-col gap-4 lg:gap-5">
            {(generatedDocumentStatuses?.length ?? 0) === 1 && (
              <p className="body">
                <span className="font-semibold">
                  {i18n.t(
                    'Dalsze procesowanie wymaga, aby właściciel podpisał dokument.'
                  )}
                </span>{' '}
                {i18n.t(
                  'Dokumenty wysyłamy na wskazany adres mailowy i numer telefonu.'
                )}
              </p>
            )}
            {(generatedDocumentStatuses?.length ?? 0) > 1 && (
              <p className="body">
                <span className="font-semibold">
                  {i18n.t(
                    'Dalsze procesowanie wymaga, aby właściciel oraz każdy ze współwłaścicieli podpisali dokumenty indywidualnie.'
                  )}
                </span>{' '}
                {i18n.t(
                  'Dokumenty wysyłamy jednocześnie na wskazane adresy mailowe i numery telefonów.'
                )}
              </p>
            )}
            <div className="flex flex-col gap-4">
              {generatedDocumentStatuses?.map((item, index) => (
                <SignBadge
                  key={`${index}-${item}`}
                  name={item.full_name}
                  status={item.status}
                />
              ))}
            </div>
            {!isReady && (
              <Button
                disabled={!!disabled || sentDocuments.isPending}
                loading={sentDocuments.isPending}
                className="w-full px-0 xxs:px-6 lg:w-full"
                onClick={async () => {
                  await sentDocuments.mutateAsync();
                }}
              >
                {disabled
                  ? `${i18n.t('Wyślij ponownie za')} ${Number(duration) === 0 && prevState !== 0 ? 2 : duration} ${formattedMinutes}`
                  : i18n.t('Wyślij do podpisu')}
                {!disabled && <ButtonRightArrow className="hidden xs:flex" />}
                <ButtonLoading />
              </Button>
            )}

            {isReady && (
              <Button
                disabled={sentDocuments.isPending}
                loading={sentDocuments.isPending}
                className="w-full px-0 xxs:px-6 lg:w-full"
                onClick={async () => {
                  localStorage.removeItem('refreshCountSigningDocuments');
                  await mutateAsync({
                    form_data: {
                      stepper: {
                        step: 8,
                        innerStep: { ...innerObject, [step]: innerStep },
                      },
                    },
                  });
                  await submitStages.mutateAsync(data.stage, {
                    onSuccess: () => {
                      setStep(8);
                    },
                  });
                }}
                data-testid="document-move-forward-button"
              >
                {i18n.t('Przejdź dalej')}
                <ButtonRightArrow className="hidden xs:flex" />
                <ButtonLoading />
              </Button>
            )}

            {documentsSent && !!disabled && (
              <Hint variant="primary">
                <Hint.Title>{i18n.t('Sprawdź e-mail lub telefon')}</Hint.Title>
                <Hint.Description className="caption-large font-jakarta lg:text-xs">
                  {i18n.t(
                    'Dokumenty do podpisu wysłaliśmy na Twój adres e-mail lub telefon. Jeśli nie widzisz ich na swojej skrzynce pocztowej, odczekaj chwilę i wyślij ponownie.'
                  )}
                </Hint.Description>
              </Hint>
            )}
          </div>
        </>
      </AfterDoc> */}
      <SummaryModal open={modalSummary} toggle={toggleModalSummary} />
    </>
  );
};

export default SignDocuments;
